import { H4, LI, P } from "../../../../AbstractElements";
import { UpdatedProduct } from "../../../../Constant";

export const StaticVariationTimeline=()=> {
  return (
    <LI className="d-flex mb-2">
      <div className="activity-dot-primary"></div>
      <div className="w-100 ms-3">
        <P className="d-flex justify-content-between mb-2">
          <span className="date-content light-background">8th March, 2022 </span>
          <span>1 day ago</span>
        </P>
        <H4 className="f-w-700">{UpdatedProduct}<span className="dot-notification"></span></H4>
        <P className="f-light">Quisque a consequat ante sit amet magna...</P>
      </div>
    </LI>
  );
}
